import { render, staticRenderFns } from "./operationInfo.vue?vue&type=template&id=2b105c9e&scoped=true"
import script from "./operationInfo.vue?vue&type=script&lang=js"
export * from "./operationInfo.vue?vue&type=script&lang=js"
import style0 from "./operationInfo.vue?vue&type=style&index=0&id=2b105c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b105c9e",
  null
  
)

export default component.exports